import { render, staticRenderFns } from "./AddModal.vue?vue&type=template&id=6bf4cf73&scoped=true"
import script from "./AddModal.vue?vue&type=script&lang=js"
export * from "./AddModal.vue?vue&type=script&lang=js"
import style0 from "./AddModal.vue?vue&type=style&index=0&id=6bf4cf73&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf4cf73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bf4cf73')) {
      api.createRecord('6bf4cf73', component.options)
    } else {
      api.reload('6bf4cf73', component.options)
    }
    module.hot.accept("./AddModal.vue?vue&type=template&id=6bf4cf73&scoped=true", function () {
      api.rerender('6bf4cf73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/AddModal.vue"
export default component.exports